import { create } from "zustand"

export const useMobileStore = create((set) => ({
  isMobile: window.innerWidth < 1024,
  setIsMobile: (isMobile) => set({ isMobile: isMobile }),
}))
